(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('CompendiumReportGroupDialogController', CompendiumReportGroupDialogController);

    CompendiumReportGroupDialogController.$inject = ['CompendiumReportGroup', 'entity', '$uibModalInstance', '$timeout', '$scope'];

    function CompendiumReportGroupDialogController(CompendiumReportGroup, entity, $uibModalInstance, $timeout, $scope) {
        var vm = this;

        vm.reportGroup = entity;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reportGroup.id !== null) {
                CompendiumReportGroup.update(vm.reportGroup, onSaveSuccess, onSaveError);
            } else {
                CompendiumReportGroup.save(vm.reportGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:compendiumReportGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    };
})();
